import React from "react";
import { useLocation } from "react-router-dom";
import ShippingPresets from "components/Shipements/ShippingPresets";

function SignageShippingPresets() {
  const location = useLocation();
  
  // Determine the base route based on current location
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  
  return <ShippingPresets baseRoute={baseRoute} />;
}

export default SignageShippingPresets;
